const calendar = {

  // Check whether a date in form dd-mm-yyyy is today
  checkIfToday(date) {
    return Date.today().toString('dd-MM-yyyy') == date;
  },

  // Return an array of dates & days, and whether they are available
  getMonthItems(monthOffset) {

    // Don't forget this starts at 0.
    // [ day name, available?bool, day of week number, is current day?bool, date code (dd-mm-yyyy) ]
    let monthItems = [];

    // Get the first day of the month
    let monthAsDate = Date.today().moveToFirstDayOfMonth();

    if (monthOffset != '0') {
      monthAsDate = Date.parse(monthOffset + ' month' + (Math.abs(parseInt(monthOffset)) == 1 ? '' : 's')).clearTime().moveToFirstDayOfMonth();
    }

    let monthAsDateIterative = monthAsDate;

    // Get the number of days in the month (starts at 0)
    const daysInMonth = Date.getDaysInMonth(parseInt(monthAsDate.toString('yyyy')), parseInt(monthAsDate.toString('M')) - 1);

    // Add the first weekday to the array
    const firstDay = monthAsDate.toString('dddd');
    monthItems.push([firstDay, true, Date.getDayNumberFromName(firstDay), module.exports.checkIfToday(monthAsDate.toString('dd-MM-yyyy')), monthAsDate.toString('dd-MM-yyyy')]);

    // Iterate through the days of the month and add the weekday to the array
    for (let i = 1; i < daysInMonth; i++) {
      const day = monthAsDateIterative.addDays(1);
      const dayName = day.toString('dddd');
      monthItems.push([dayName, true, Date.getDayNumberFromName(dayName), module.exports.checkIfToday(day.toString('dd-MM-yyyy')), day.toString('dd-MM-yyyy')]);
    }

    const availability = $('.tr-calendar-wrap').data('availability');
    const freeDays = $('.tr-calendar-wrap').data('free-days');

    // Iterate through the month items and set them to false if they are unavailable
    monthItems.forEach((item, dateOfMonth) => {
      item[1] = availability[parseInt(monthOffset)][String(dateOfMonth + 1).padStart(2, '0')];

      // Free days
      let freeDay = false;

      if (typeof freeDays[parseInt(monthOffset)] !== 'undefined') {
        if (typeof freeDays[parseInt(monthOffset)][String(dateOfMonth + 1).padStart(2, '0')] !== 'undefined') {
          freeDay = true;
        }
      }

      item[5] = freeDay;
    });

    return monthItems;
  },
  
  // Populate the front-end calendar with the available dates and unavailable dates.
  populateCalendarMonth(monthOffset) {
    const $calendarHead = $('.tr-calendar-wrap .tr-calendar-head');
    const $calendarBody = $('.tr-calendar-wrap .tr-calendar-body');

    // Reset the calendar
    $calendarBody.find('.tr-calendar-week-day').addClass('not-visible').removeClass('unavailable').removeClass('free').removeClass('current-day').removeClass('selected').html('').data('full-date', '');

    // Get the available dates - offset must be in form of -3, 0, +3 for example
    var monthOffsetFriendly = monthOffset;

    if (monthOffsetFriendly > 0) {
      monthOffsetFriendly = '+' + String(monthOffsetFriendly);
    } else {
      monthOffsetFriendly = String(monthOffsetFriendly);
    }

    const monthItems = module.exports.getMonthItems(monthOffsetFriendly);

    // Set the calendar title
    let monthAsDate = Date.today().moveToFirstDayOfMonth();

    if (monthOffsetFriendly != '0') {
      monthAsDate = Date.parse(monthOffsetFriendly + ' month' + (Math.abs(parseInt(monthOffsetFriendly)) == 1 ? '' : 's')).clearTime().moveToFirstDayOfMonth();
    }

    let monthName = monthAsDate.toString('MMMM');
    const yearName = monthAsDate.toString('yyyy');

    if ($('html').attr('lang') == 'cy-GB') {
      monthName = $(`#month-name-translations span[data-month-en="${monthName}"]`).data('month-cy');
    }

    $calendarHead.find('.tr-calendar-month').html(monthName + ' ' + yearName);

    // Start from the first day of the month
    const firstDay = monthItems[0];

    const $firstDayItem = $calendarBody.find(`.tr-calendar-week-day[data-week-code="0"][data-day-code="${firstDay[2]}"]`);
    $firstDayItem.removeClass('not-visible');
    $firstDayItem.data('date', 1);
    $firstDayItem.data('available', firstDay[1]);
    $firstDayItem.data('full-date', firstDay[4]);
    $firstDayItem.html('<span>1</span>');

    if (!firstDay[1]) {
      $firstDayItem.addClass('unavailable');
    }

    if (firstDay[3]) {
      $firstDayItem.addClass('current-day');
    }

    if (firstDay[4] == $('.tr-calendar-wrap').data('chosen-date')) {
      $firstDayItem.addClass('selected');
    }

    const firstDayIndex = $firstDayItem.data('index');

    // Iterate through the remaining days
    monthItems.forEach((monthItem, key) => {
      if (key > 0) {
        const $thisDayItem = $calendarBody.find(`.tr-calendar-week-day[data-index="${firstDayIndex + key}"]`);
        $thisDayItem.removeClass('not-visible');
        $thisDayItem.data('date', key + 1);
        $thisDayItem.data('available', monthItem[1]);
        $thisDayItem.data('full-date', monthItem[4]);
        $thisDayItem.html(`<span>${key + 1}</span>`);

        if (!monthItem[1]) {
          $thisDayItem.addClass('unavailable');
        }

        if (monthItem[3]) {
          $thisDayItem.addClass('current-day');
        }

        if (monthItem[4] == $('.tr-calendar-wrap').data('chosen-date')) {
          $thisDayItem.addClass('selected');
        }

        if (monthItem[5]) {
          $thisDayItem.addClass('free');
          $thisDayItem.append('<small>FREE</small>');
        }
      }
    });
  },

  instantiate() {
    const maximumMonthOffset = $('.tr-calendar-wrap').data('max-months'); // Number of months into the future you can book

    // Go back a month
    $('.tr-calendar-wrap .tr-calendar-head .tr-calendar-month-prev').on('click', function() {
      const currentOffset = parseInt($('.tr-calendar-wrap').data('month-offset'));

      if (currentOffset > 0) {
        const offset = currentOffset - 1;
        $('.tr-calendar-wrap').data('month-offset', offset);

        module.exports.populateCalendarMonth(offset);
      }
    });

    // Go forward a month
    $('.tr-calendar-wrap .tr-calendar-head .tr-calendar-month-next').on('click', function() {
      const currentOffset = parseInt($('.tr-calendar-wrap').data('month-offset'));

      if (currentOffset + 1 < maximumMonthOffset) {
        const offset = currentOffset + 1;
        $('.tr-calendar-wrap').data('month-offset', offset);

        module.exports.populateCalendarMonth(offset);
      }
    });
  },
}

module.exports = calendar;


// WEBPACK FOOTER //
// ./scripts/util/calendar.js